import { motion } from "framer-motion";

/**
 * Clean image tile — no overlays, no chips. Used for images that already have
 * their own device framing (like laptop mockups) or for visuals that should feel
 * uncropped (like a Miro journey map).
 *
 * If you need a browser-chrome mockup, use BrowserFrame instead.
 */
const MediaFrame = ({
  src,
  alt = "Case study asset",
  ratio = "16/9",
  className = "",
  testid,
  caption,
  fit = "cover",
  padded = false,
  padColor = "bg-[color:var(--nn-elev)]",
}) => {
  return (
    <div className="flex flex-col gap-3">
      <motion.figure
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-10% 0px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className={`relative rounded-3xl overflow-hidden border border-[color:var(--nn-border)] ${padded ? padColor : "bg-transparent"} ${padded ? "p-4 md:p-8" : ""} group ${className}`}
        style={{ aspectRatio: padded ? undefined : ratio }}
        data-testid={testid}
      >
        <div
          className={padded ? "relative w-full rounded-2xl overflow-hidden" : "absolute inset-0"}
          style={padded ? { aspectRatio: ratio } : undefined}
        >
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className={`w-full h-full object-${fit} object-top transition-transform duration-[1400ms] group-hover:scale-[1.02] ${padded ? "" : "absolute inset-0"}`}
          />
        </div>
      </motion.figure>
      {caption && (
        <figcaption className="font-mono text-[10px] md:text-[11px] uppercase tracking-widest text-[color:var(--nn-muted)] px-2">
          <span className="text-[color:var(--nn-accent-text)]">▚</span> {caption}
        </figcaption>
      )}
    </div>
  );
};

export default MediaFrame;
